export interface ChangelogEntry {
  date: string;
  title: string;
  body: string;
}

export interface ChangelogIndexEntry {
  date: string;
  title: string;
  file: string;
}

export const CHANGELOG_BASE_URL = "/changelog";

/**
 * Resolves document-relative image srcs (e.g. `images/foo.png`) against
 * CHANGELOG_BASE_URL so entries preview correctly both in-app and on GitHub.
 */
export function resolveChangelogAssetPaths(body: string): string {
  return body.replace(
    /(<img\s[^>]*?src=")(?!https?:|\/)/g,
    `$1${CHANGELOG_BASE_URL}/`
  );
}

/**
 * Splits `---` delimited YAML frontmatter from the markdown body.
 * Returns { frontmatter: Record<string, string>, body: string }.
 */
export function parseFrontmatter(raw: string): {
  frontmatter: Record<string, string>;
  body: string;
} {
  const trimmed = raw.trim();
  if (!trimmed.startsWith("---")) {
    return { frontmatter: {}, body: trimmed };
  }

  const end = trimmed.indexOf("---", 3);
  if (end === -1) {
    return { frontmatter: {}, body: trimmed };
  }

  const fmBlock = trimmed.slice(3, end).trim();
  const body = trimmed.slice(end + 3).trim();

  const frontmatter: Record<string, string> = {};
  for (const line of fmBlock.split("\n")) {
    const colonIdx = line.indexOf(":");
    if (colonIdx === -1) continue;
    const key = line.slice(0, colonIdx).trim();
    const value = line.slice(colonIdx + 1).trim();
    frontmatter[key] = value;
  }

  return { frontmatter, body };
}

